import axiosApi from '../api/axiosApi';
import { GET_PROCESSES } from '../common/constants/constants';

class ProcessesService {
  getProcesses() {
    return axiosApi.get(GET_PROCESSES);
  }
}

export default new ProcessesService();
